/**
 * @generated SignedSource<<fc2a00eccb7d4432f84dd747f42808c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getFacilityMemberPermissions_facility$data = {
  readonly club: {
    readonly id: string;
    readonly supportsPrivate: boolean;
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly privateBookingPermissionSet: {
    readonly areOtherBookingsJoinable: boolean | null | undefined;
    readonly areOtherBookingsVisible: boolean | null | undefined;
    readonly canBookOnBusySlot: boolean | null | undefined;
    readonly id: string;
    readonly isFacilityBookable: boolean | null | undefined;
    readonly isFacilityVisible: boolean | null | undefined;
  } | null | undefined;
  readonly publicBookingPermissionSet: {
    readonly areOtherBookingsJoinable: boolean | null | undefined;
    readonly areOtherBookingsVisible: boolean | null | undefined;
    readonly canBookOnBusySlot: boolean | null | undefined;
    readonly id: string;
    readonly isFacilityBookable: boolean | null | undefined;
    readonly isFacilityVisible: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "getFacilityMemberPermissions_facility";
};
export type getFacilityMemberPermissions_facility$key = {
  readonly " $data"?: getFacilityMemberPermissions_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"getFacilityMemberPermissions_facility">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getFacilityMemberPermissions_facility"
};

(node as any).hash = "81271c496432b8322a0893fefce96f66";

export default node;
